import { Mail, MapPin, Globe, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./primitives";
import { COMPANY } from "./data";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative overflow-hidden bg-[#1a6fc4] py-28 text-white sm:py-36"
    >
      <div className="absolute inset-0 pm-grid-blue opacity-50" />
      <div className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#5aa72f]/25 blur-3xl" />
      <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[#0e3f70]/50 blur-3xl" />

      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <Overline dark>Get in touch</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mx-auto mt-6 max-w-3xl font-heading text-4xl font-bold leading-[1.06] tracking-tight sm:text-5xl">
            Let&rsquo;s plan smarter agricultural pipelines together
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/80">
            Reach out to learn more about PipeMitra and how engineering-based
            pipeline planning can support your work.
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <a
            data-testid="send-email-btn"
            href={`mailto:${COMPANY.email}`}
            className="group mt-10 inline-flex items-center gap-2.5 rounded-full bg-white px-8 py-4 text-base font-semibold text-[#0e3f70] transition-all duration-300 hover:bg-[#eaf3fb] active:scale-[0.98]"
          >
            <Mail className="h-5 w-5" />
            Send us an Email
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mx-auto mt-14 grid max-w-3xl gap-4 sm:grid-cols-3">
            <div className="rounded-2xl border border-white/15 bg-white/[0.06] p-5 text-left backdrop-blur-sm">
              <MapPin className="h-5 w-5 text-[#a6d47a]" />
              <p className="mt-3 font-mono text-[11px] uppercase tracking-wider text-white/60">
                Location
              </p>
              <p className="mt-1 text-sm font-medium">{COMPANY.location}</p>
            </div>
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="contact-email-link"
              className="rounded-2xl border border-white/15 bg-white/[0.06] p-5 text-left backdrop-blur-sm transition-colors hover:bg-white/[0.12]"
            >
              <Mail className="h-5 w-5 text-[#a6d47a]" />
              <p className="mt-3 font-mono text-[11px] uppercase tracking-wider text-white/60">
                Email
              </p>
              <p className="mt-1 text-sm font-medium">{COMPANY.email}</p>
            </a>
            <div className="rounded-2xl border border-white/15 bg-white/[0.06] p-5 text-left backdrop-blur-sm">
              <Globe className="h-5 w-5 text-[#a6d47a]" />
              <p className="mt-3 font-mono text-[11px] uppercase tracking-wider text-white/60">
                Website
              </p>
              <p className="mt-1 text-sm font-medium">{COMPANY.website}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
